import { geodesicBuffer } from '@arcgis/core/geometry/geometryEngine';
import Point from '@arcgis/core/geometry/Point';
import Graphic from '@arcgis/core/Graphic';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import * as turf from '@turf/turf';

import { FsMap } from '@lib/geo/map';

import { FsShapeStyles } from '../helpers';
import { ShapeStylesType } from '../types';
import { FsMapShape } from './shapes';

export class FsMapCircle extends FsMapShape {
  public shapeType = 'circle';

  constructor(public shape?: any) {
    super({
      shape,
    });
  }

  public createCircle(
    center: any,
    radius: number,
    style: ShapeStylesType,
    map: FsMap,
  ): FsMapCircle {
    switch (this.defaultMapSource) {
      case 'google':
        this.shape = new google.maps.Circle({
          center: { lat: center.lat, lng: center.lng },
          radius: radius,
          ...style,
        });
        this.map = map;
        this.listenForGoogleShapeEvents();

        return this;

      case 'esri':
        const centerPoint = new Point({
          latitude: center.lat,
          longitude: center.lng,
          spatialReference: { wkid: 4326 },
        });

        let circleGeometry = geodesicBuffer(centerPoint, radius, 'meters');

        if (Array.isArray(circleGeometry)) {
          circleGeometry = circleGeometry[0];
        }

        const styles: any = new FsShapeStyles({ ...style }).styles;
        const simpleFill = new SimpleFillSymbol(styles);

        this.shape = new Graphic({
          attributes: {
            id: crypto.randomUUID(),
          },
          geometry: circleGeometry,
          symbol: simpleFill,
        });

        this.map = map;

        this.setupEsriClickHandler();

        return this;
    }
  }

  public getGeometry(): any {
    return turf.geometry('Polygon', [this.getPath()]);
  }
}
